import $ from 'jquery';

const productFilterPopupV1Semantics = {
    mainWrapClass: 'product-filter-popup-v1',
    isInitializedAttribute: 'data-is-initialized',
    instanceIdAttribute: 'data-instance-id',
    closeBtn: 'product-filter-popup-v1__close',
    initiatorAttr: 'data-initiator',

}

$(function () {
    ProductFilterPopupV1.init()
})

class ProductFilterPopupV1 {

    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        let roots = $(`.${productFilterPopupV1Semantics.mainWrapClass}`);
        if (roots.length === 0) {
            return false;
        }
        if (!window || !window.widgets || !window.widgets.productFilterPopupV1) {
            window.widgets.productFilterPopupV1 = new ProductFilterPopupV1();
        }
        /**
         * Checking other instances
         */
        roots.each((index, el) => {
            let isInitialized =
                ($(el).attr(`${productFilterPopupV1Semantics.isInitializedAttribute}`) === 'true');

            if (!isInitialized) {
                window.widgets.productFilterPopupV1.registerInstance($(el));
                window.widgets.productFilterPopupV1.registerListeners($(el));
            }
        });
    }

    registerInstance(el) {
        let instanceId =
            el.attr(`${productFilterPopupV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }
        try {
            el.attr(`${productFilterPopupV1Semantics.isInitializedAttribute}`, true);
            window.widgets.productFilterPopupV1.pluginInstances[instanceId] = el;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
        let elements = $(`.${productFilterPopupV1Semantics.mainWrapClass}[${
                productFilterPopupV1Semantics
                        .instanceIdAttribute
        }="${
                el.attr(productFilterPopupV1Semantics
                        .instanceIdAttribute)
        }"]`);

        elements.on(
            'click',
            `.${productFilterPopupV1Semantics.closeBtn}`,
            (e) => {
                e.preventDefault();
                 //mvp
                window.widgets.tagListV12.closePopup();
            }
        );
    }

    reInit(instanceId) {
        if (this.pluginInstances[instanceId] !== undefined) {
            this.registerListeners(this.pluginInstances[instanceId]);
        } else {
            ProductFilterPopupV1.init()
        }
    }
}

export default ProductFilterPopupV1;